"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (data) {
    if (data === void 0) { data = {}; }
    return ({
        action: 'devSyncResp',
        code: 200,
        desc: 'success',
        msgId: virtual.msgId,
        params: __assign({ devTid: virtual.device.devTid }, data)
    });
}; });



// WEBPACK FOOTER //
// ./src/actions/send/actions/devSyncResp.ts